// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddReadingListNode__container___SEplk {
    margin-top: 8px;
}

.AddReadingListNode__searchRow___sRLiT {
    display: flex;
    align-items: stretch;
    gap: 7px;
}

.AddReadingListNode__searchInput___aU5R0 {
    box-sizing: border-box;
    min-width: 0;
    height: 34px;
    flex: 1;
    padding: 6px 9px;
    border: 1px solid rgba(173, 139, 62, 0.28);
    border-radius: 2px;
    outline: none;
    background: rgba(0, 0, 0, 0.42);
    color: rgba(235, 230, 211, 0.9);
    font-family: "Montaga";
    font-size: 14px;
}

.AddReadingListNode__searchInput___aU5R0:focus {
    border-color: rgba(222, 174, 70, 0.62);
    box-shadow: 0 0 7px rgba(222, 174, 70, 0.24);
}

.AddReadingListNode__addButton___SMGDz {
    min-width: 66px;
    border: 1px solid rgba(173, 139, 62, 0.32);
    border-radius: 2px;
    background: rgba(116, 83, 25, 0.22);
    color: #d9bf72;
    font-family: "Montaga";
}

.AddReadingListNode__addButton___SMGDz:disabled {
    cursor: default;
    opacity: 0.35;
}

.AddReadingListNode__addButton___SMGDz:not(:disabled):hover,
.AddReadingListNode__addButton___SMGDz:not(:disabled):focus {
    outline: none;
    background: rgba(116, 83, 25, 0.38);
    color: #fff5ce;
}

.AddReadingListNode__results___cHfMJ {
    margin-top: 4px;
    margin-right: 73px;
    border: 1px solid rgba(173, 139, 62, 0.22);
    background: rgba(2, 3, 3, 0.96);
}

.AddReadingListNode__spinner___d6GDA {
    margin: 6px 73px 0 0;
    text-align: center;
}

.AddReadingListNode__searchMessage___Ke56D {
    margin: 6px 73px 0 2px;
    color: rgba(210, 205, 190, 0.52);
    font-family: "Montaga";
    font-size: 12px;
}

.AddReadingListNode__result___XRj3k {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 12px;
    padding: 7px 9px;
    border: 0;
    border-bottom: 1px solid rgba(173, 139, 62, 0.14);
    background: transparent;
    color: rgba(235, 230, 211, 0.84);
    text-align: left;
}

.AddReadingListNode__result___XRj3k:last-child {
    border-bottom: 0;
}

.AddReadingListNode__result___XRj3k:hover,
.AddReadingListNode__result___XRj3k:focus {
    outline: none;
    background: rgba(116, 83, 25, 0.24);
    color: #fff5ce;
}

.AddReadingListNode__result___XRj3k:disabled {
    cursor: default;
    color: rgba(235, 230, 211, 0.5);
}

.AddReadingListNode__result___XRj3k:disabled:hover {
    background: transparent;
}

.AddReadingListNode__result___XRj3k span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.AddReadingListNode__result___XRj3k small {
    flex: none;
    color: rgba(210, 205, 190, 0.46);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddReadingListNode__container___SEplk`,
	"searchRow": `AddReadingListNode__searchRow___sRLiT`,
	"searchInput": `AddReadingListNode__searchInput___aU5R0`,
	"addButton": `AddReadingListNode__addButton___SMGDz`,
	"results": `AddReadingListNode__results___cHfMJ`,
	"spinner": `AddReadingListNode__spinner___d6GDA`,
	"searchMessage": `AddReadingListNode__searchMessage___Ke56D`,
	"result": `AddReadingListNode__result___XRj3k`
};
module.exports = ___CSS_LOADER_EXPORT___;
